import React, { Component } from "react";
import PrintPreview from "./PrintPreview";
// import JobControlBoardTable from '../workdoc/jobcontrol/JobControlBoardTable'
import ReportWorkTable from "../report/ReportWorkTable";
import ReportStore from "stores/ReportStore";
import { momentHelper } from "../report/helpers";
const MobileDetect = require("mobile-detect");
class PrintReportWork extends Component {
  constructor(...args) {
    super(...args);
    let md = new MobileDetect(window.navigator.userAgent);
    let sliptable_page = "sliptable-page-destop iv-olview";
    let title_destop = "title-destop";
    if (md.is("iOS") || md.is("AndroidOS")) {
      sliptable_page = "sliptable-page iv-olview";
      title_destop = "";
    }

    this.state = {
      loading: false,
      componentList: [],
      itemPerPage: 10,
      startRow: 10,
      endRow: 20,
      title_destop: title_destop,
      sliptable_page: sliptable_page,
      report_title: "กำลังดึงข้อมูล..",
    };
  }

  componentDidMount() {
    let { itemPerPage } = this.state;
    let { showDetail } = this.props;
    if (showDetail === "true") {
      itemPerPage = 2;
      let item = {
        defaultRows: itemPerPage,
        startRowPerPage: 1,
        endRowPerPage: 20,
      };
      this.refs.preview.getWrappedInstance().setItemPerPageOption(item);
      this.setState({ itemPerPage: itemPerPage });
    }
    this.loadWorkList(itemPerPage);
  }

  // componentDidUpdate(){
  //   const {componentList,workState} = this.state
  //   const that = this
  //   componentList.map((item,index)=>{

  //     that.refs['jcbTable'+index].loadData(item,workState)
  //     return item
  //   })
  // }

  setData(result, itemPerPage) {
    const data = result.data;
    const length = Math.ceil(data.length / itemPerPage);

    const componentList = new Array(length).fill("").map((item, index) => {
      let newData = data.slice(index * itemPerPage, (index + 1) * itemPerPage);
      return newData;
    });

    this.setState({ loading: false, componentList: componentList });
  }

  getDate() {
    let { day, year, month, isRange, startDate, endDate } = this.props;
    if (isRange === "true") {
      let start = startDate;
      let end = endDate;
      return "ประจำวันที่ " + start + " - " + end;
    } else {
      let text = "ประจำเดือน ";
      text += " " + momentHelper.getMonthText(month) + " " + (year - 543);
      if (year === "0" || year === "00" || year === 0) {
        text = "ทั้งหมด";
      } else if (month === "0" || month === "00" || month === 0) {
        text = "ประจำปี " + (year - 543);
      } else if (day === "0" || day === "00" || day === 0) {
        text =
          "ประจำเดือน " + momentHelper.getMonthText(month) + " " + (year - 543);
      }
      return text;
    }
  }

  loadWorkList(
    itemPerPage,
    filter = { showUnprocessFinance: false, hasAdvanceDate: false }
  ) {
    this.setState({ loading: true });
    let { column_title } = this.state;
    let { apiCall, year, month, showDetail, query, cat } = this.props;
    ReportStore.loadReportWork(
      apiCall,
      year,
      month,
      showDetail,
      0,
      "",
      query,
      cat,
      filter,
      (result) => {
        this.setData(result, itemPerPage);
        column_title = result.column_title.map((item, index) => {
          item = Object.assign({ seq_no: index + 1 }, item);
          return item;
        });
        this.setState({
          loading: false,
          report_title: "ไม่พบข้อมูล",
          column_index: result.column_index,
          column_title: column_title,
        });
      },
      () => {
        this.setState({ loading: false, report_title: "เกิดข้อผิดพลาด" });
      }
    );
  }

  renderComponentPage() {
    const { componentList, column_index, column_title } = this.state;
    let {
      showStatus,
      autoRefresh,
      showDetail,
      chassisPrimary,
      rowClass,
      apiCall,
    } = this.props;
    let title = "";
    if (apiCall === "all") {
      title = "รายงานทั้งหมด ";
    } else if (apiCall === "new") {
      title = "รายงานเริ่มต้น ";
    } else if (apiCall === "no_quotation") {
      title = "รายงานค้างเสนอราคา ";
    } else if (apiCall === "no_job") {
      title = "รายงานยังไม่ออกใบจ็อบ ";
    } else if (apiCall === "nopark") {
      title = "รายงานรถไม่จอดซ่อม/รอจอด ";
    } else if (apiCall === "start") {
      title = "รายงานอยู่ระหว่างซ่อม ";
    } else if (apiCall === "wait_for_customer") {
      title = "รายงานรอส่งมอบรถ ";
    } else if (apiCall === "wait_for_payment") {
      title = "รายงานส่งรถแล้ว/รอตั้งเบิก ";
    } else if (apiCall === "job_done") {
      title = "รายงานปิดจบงาน ";
    } else if (apiCall === "payment_received") {
      title = "รายงานรับเงินแล้ว ";
    } else if (apiCall === "credit") {
      title = "รายงานเครดิต ";
    } else if (apiCall === "receiving") {
      title = "รายงานรถเข้า ";
    } else if (apiCall === "delivering") {
      title = "รายงานรถออก ";
    } else if (apiCall === "junk") {
      title = "รายงานงานยกเลิก ";
    }
    let _autoRefresh = autoRefresh === "true" ? true : false;
    if (componentList.length === 0) {
      return this.renderNoData();
    }
    return componentList.map((item, index) => (
      <div className="a4-onlineview landscape print-report-work" key={index}>
        <div
          className={
            this.state.sliptable_page +
            " landscape workjob print-report-work font-print"
          }
        >
          <div>
            <div>
              <div className="text-center">
                <h3>
                  <b>{title + this.getDate()}</b>
                </h3>
              </div>
            </div>
            <ReportWorkTable
              rowClass={rowClass}
              data={item}
              type={"print"}
              columnIndex={column_index}
              columnTitle={column_title}
              showStatus={showStatus === "true" ? true : false}
              showAmount={!_autoRefresh}
              showDetail={showDetail === "true" ? true : false}
              chassisPrimary={chassisPrimary === "true" ? true : false}
              onRowWorkClick={() => {}}
            />
          </div>
        </div>
      </div>
    ));
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({ itemPerPage: itemPerPage }, () => {
      this.loadWorkList(itemPerPage);
    });
  }

  renderNoData() {
    return (
      <div className="a4-onlineview landscape">
        <div className={this.state.sliptable_page + " landscape workjob"}>
          <div className="">
            <div className="no-of-page">
              <span>
                <br />
              </span>
            </div>
            <header className="align-center font-print">
              <h2 className={""}>{this.state.report_title}</h2>
            </header>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, startRow, endRow, itemPerPage } = this.state;
    return (
      <PrintPreview
        ref="preview"
        loading={loading}
        size={"landscape"}
        leftBarTitle={"รายงานงานทั้งหมด"}
        onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
        defaultRowPerPage={itemPerPage}
        startRowPerPage={startRow}
        endRowPerPage={endRow}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    );
  }
}

export default PrintReportWork;



// WEBPACK FOOTER //
// ./src/view/print/PrintReportWork.js